/**
 * Which datasets an automation reads. Reports and alerts carry
 * `report_dataset_ids`; the ingest wizard's automations carry a single
 * `dataset_id` (the dataset they write to). Ids are compared as strings — the
 * API hands them back in either type.
 */
export const automationDatasetIds = (automation) => {
  const ids = Array.isArray(automation?.report_dataset_ids) ? automation.report_dataset_ids : [];
  const all = automation?.dataset_id ? [automation.dataset_id, ...ids] : ids;
  return [...new Set(all.map(String))];
};

/** Every dataset id named by any automation in the list, deduplicated. */
export const allAutomationDatasetIds = (automations) =>
  [...new Set((automations || []).flatMap(automationDatasetIds))];

/** The dataset RECORDS behind one automation, from a loaded list. */
export const datasetsForAutomation = (automation, datasets) => {
  const wanted = new Set(automationDatasetIds(automation));
  return (datasets || []).filter((d) => wanted.has(String(d.id)));
};
